import React, {useEffect} from 'react';
import Header from "../components/Header";
import CustomeNavbar from "../components/CustomeNavbar";
import ToTop from "../components/ToTop";
import Footer from "../components/Footer";
import SurveiMasyarakatContent from "../contents/SurveiMasyarakatContent";

const SurveiMasyarakat = () => {
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    useEffect(() => {
        scrollToTop();
    }, []);
    return (
        <div>
            <Header/>
            <CustomeNavbar/>
            <SurveiMasyarakatContent />
            <ToTop/>
            <Footer/>
        </div>
    );
};

export default SurveiMasyarakat;